"use client";

import { useEffect } from "react";

const RELOAD_KEY = "tezam_error_reload_once";

function isDeployMismatch(error: Error): boolean {
    const msg = `${error?.message || ""} ${error?.name || ""}`;
    return (
        /Failed to find Server Action/i.test(msg) ||
        /Server Reference ID/i.test(msg) ||
        /ChunkLoadError/i.test(msg) ||
        /Loading chunk [\d]+ failed/i.test(msg) ||
        /Unexpected token '<'/i.test(msg) ||
        /Failed to fetch dynamically imported module/i.test(msg)
    );
}

/**
 * Ловит клиентские падения App Router (часто после деплоя — старый JS / Server Action).
 * Один раз делает hard reload; иначе показывает кнопку «Обновить».
 */
export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
    useEffect(() => {
        console.error("[tezam error boundary]", error);
        if (typeof window === "undefined") return;
        if (!isDeployMismatch(error)) return;
        try {
            if (sessionStorage.getItem(RELOAD_KEY) === "1") return;
            sessionStorage.setItem(RELOAD_KEY, "1");
            window.location.reload();
        } catch {
            /* ignore */
        }
    }, [error]);

    return (
        <div
            style={{
                minHeight: "60vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 16,
                padding: 24,
                fontFamily: "system-ui, sans-serif",
                color: "#0f172a",
                textAlign: "center",
            }}
        >
            <h1 style={{ margin: 0, fontSize: 22 }}>Что-то пошло не так</h1>
            <p style={{ margin: 0, maxWidth: 420, color: "#64748b", lineHeight: 1.45 }}>
                Страница не загрузилась. Обычно помогает обновление — особенно после выкладки новой версии сайта.
            </p>
            <div style={{ display: "flex", gap: 10, flexWrap: "wrap", justifyContent: "center" }}>
                <button
                    type="button"
                    onClick={() => {
                        try {
                            sessionStorage.removeItem(RELOAD_KEY);
                        } catch {
                            /* ignore */
                        }
                        window.location.reload();
                    }}
                    style={{
                        border: "none",
                        borderRadius: 10,
                        padding: "10px 18px",
                        background: "#229ed9",
                        color: "#fff",
                        fontWeight: 700,
                        cursor: "pointer",
                    }}
                >
                    Обновить страницу
                </button>
                <button
                    type="button"
                    onClick={() => {
                        try {
                            sessionStorage.removeItem(RELOAD_KEY);
                        } catch {
                            /* ignore */
                        }
                        reset();
                    }}
                    style={{
                        border: "1px solid #cbd5e1",
                        borderRadius: 10,
                        padding: "10px 18px",
                        background: "#fff",
                        color: "#0f172a",
                        fontWeight: 600,
                        cursor: "pointer",
                    }}
                >
                    Попробовать снова
                </button>
            </div>
        </div>
    );
}
